var _circle, _path, _path2, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 75,
    viewBox: "0 0 51 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 25.5,
    r: 25.5,
    fill: "#383838"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 25.8125C27.7949 25.8125 29.25 24.3574 29.25 22.5625C29.25 20.7676 27.7949 19.3125 26 19.3125C24.2051 19.3125 22.75 20.7676 22.75 22.5625C22.75 24.3574 24.2051 25.8125 26 25.8125Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.125 22.5625C34.125 29.875 26 35.5625 26 35.5625C26 35.5625 17.875 29.875 17.875 22.5625C17.875 20.4076 18.731 18.341 20.2548 16.8173C21.7785 15.2935 23.8451 14.4375 26 14.4375C28.1549 14.4375 30.2215 15.2935 31.7452 16.8173C33.269 18.341 34.125 20.4076 34.125 22.5625V22.5625Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 44.3398,
    width: 3.77358,
    height: 30.1887,
    rx: 1.88679,
    fill: "#383838"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinLocation);
export default __webpack_public_path__ + "static/media/pin_location.19753efabf879130ffb8a720777115af.svg";
export { ForwardRef as ReactComponent };